import * as contentful from '@bob/contentful-services'

import * as cold from './cold'

type NameSlug = { name: string; slug: string }
type NameSlugExtra<EXTRA> = { name: string; slug: string; extra: EXTRA }

type ExtraMoment = {
    icon: contentful.base.MomentIcon
    timeStart: string | null
    timeEnd: string | null
}
type ExtraPillar = {
    altName: string
    description: string
    icon: contentful.base.PillarIcon
    order: number | null
}

export function buildTags(
    slugs: string[],
    cold: {
        categories: cold.SlimColdData['categories']
        tags: cold.SlimColdData['tags']
        taxonomies: cold.SlimColdData['taxonomies']
    }
): {
    categories: NameSlug[]
    environmentalPillars: NameSlugExtra<ExtraPillar>[]
    productTypes: NameSlug[]
    moments: NameSlugExtra<ExtraMoment>[]
    socialPillars: NameSlugExtra<ExtraPillar>[]
    others: NameSlug[]
} {
    const categories: NameSlug[] = []

    slugs.some(slug => {
        const category = cold.categories[slug]
        if (category) {
            categories.push({
                name: category.name,
                slug
            })
            return true
        }
    })

    const environmentalPillars: NameSlugExtra<ExtraPillar>[] = []
    const productTypes: NameSlug[] = []
    const moments: NameSlugExtra<ExtraMoment>[] = []
    const socialPillars: NameSlugExtra<ExtraPillar>[] = []
    const others: NameSlug[] = []

    Object.values(cold.tags).forEach(tag => {
        if (!slugs.includes(tag.slug)) {
            return
        }

        if (cold.taxonomies['taille'].children.tags.includes(tag.slug)) {
            return
        }

        if (cold.taxonomies['couleur'].children.tags.includes(tag.slug)) {
            return
        }

        if (cold.taxonomies['genre'].children.tags.includes(tag.slug)) {
            return
        }

        if (cold.taxonomies['type-de-produit'].children.tags.includes(tag.slug)) {
            return productTypes.push({
                name: tag.name,
                slug: tag.slug
            })
        }

        if (
            cold.taxonomies['pilier-environnemental'].children.tags.includes(tag.slug) &&
            tag.extra !== null &&
            tag.extra.type === 'pillar'
        ) {
            return environmentalPillars.push({
                extra: tag.extra,
                name: tag.name,
                slug: tag.slug
            })
        }

        if (
            cold.taxonomies['pilier-social'].children.tags.includes(tag.slug) &&
            tag.extra !== null &&
            tag.extra.type === 'pillar'
        ) {
            return socialPillars.push({
                extra: tag.extra,
                name: tag.name,
                slug: tag.slug
            })
        }

        if (
            cold.taxonomies['moments'].children.tags.includes(tag.slug) &&
            tag.extra !== null &&
            tag.extra.type === 'moment'
        ) {
            return moments.push({
                extra: tag.extra,
                name: tag.name,
                slug: tag.slug
            })
        }
        return others.push({
            name: tag.name,
            slug: tag.slug
        })
    })

    return {
        categories,
        environmentalPillars,
        productTypes,
        moments,
        socialPillars,
        others
    }
}
